import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputAvtalTyp from '../Inputs/CheckBoxInputAvtalTyp'
import CheckBoxInputAvtalleverant from '../Inputs/CheckBoxInputAvtalleverant'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig'
import CheckBoxInputOrderStatus from '../Inputs/CheckBoxInputOrderStatus'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'
import CheckBoxInputWithLeventor from '../Inputs/CheckBoxInputWithLeventor'
import CheckBoxInputAnteckningar from '../Inputs/CheckBoxInputAnteckningar'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputWithKostnader from '../Inputs/CheckBoxInputWithKostnader'
import { injectIntl } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
import MultiSelectInput from '../Inputs/MultiSelectInput'

function OrderSection(props) {
    const OrderFreeInputsList = useSelector(state => state.accountsData.OrderFreeInputsList)
    const Flags = useSelector(state => state.accountsData.Flags) 
    let user = useSelector(state => state.auth.authUser)
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    console.log(OrderFreeInputsList,"AFOrderFreeInputsList")
    let TB1Lable = Flags.KalkylPlus === 1?user.user_canSeeTB1 === 1?"TB2":"TB":"TB"
    let TB2Lable = "TB"
    return (
    <>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="OrderNr" MetaN={"Order_Nr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAvtalTyp Meta="Ordertyp" MetaN={"Order_Typ"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAvtalleverant Meta="Order leverantör" MetaN={"Order_Leverantor"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Order ägare" MetaN={"Order_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order Kontor" MetaN={"Order_Office"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order beskrivning" MetaN={"Order_Beskrivning"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>

           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order affär från" MetaN={"Order_Affar_From"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Typ av affär" MetaN={"Order_TypAvAffar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputWithLeventor Meta="Med leverantör" MetaN={"Order_Mleverantör"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputWithKostnader Meta="Med Kostnader" MetaN={"Order_MKostnader"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputWithKostnader Meta="Med Kunddata" MetaN={"Order_MKunddata"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
        {/*   <CheckBoxInputOrderStatus Meta="Order status" MetaN={"Order_Status"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />*/}
           <MultiSelectInput Meta="Order status" MetaN={"Order_Status"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Senaste byter status" MetaN={"Order_Status_Last"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order antal" MetaN={"Order_Antal"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order antal ny" MetaN={"Order_Antal_Ny"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order antal förlängnig" MetaN={"Order_Antal_For"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputTaggning Meta="Order Taggar" MetaN={"Order_Tagger"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnteckningar Meta="Anteckningar" MetaN={"Order_Anteckningar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Firmatecknare" MetaN={"Order_Firmatecknare"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Porteringar (Till operatör)" MetaN={"Order_Porteringar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Mötesbokare" MetaN={"Order_Motesbokare"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Växel" MetaN={"Order_Vaxel"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Provision" MetaN={"Order_Provision"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'Total' })}`} MetaN={"Order_Varde_Totalt"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            parseInt(Flags.KalkylPlus) === 1?
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'Total' })}`} MetaN={"Order_Varde2_Totalt"}  disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
            </Grid>
            :""
            }
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris totalt" MetaN={"Order_Varde_Utpris"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order värde Inpris" MetaN={"Order_Varde_Inpris"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order TBavdrag" MetaN={"Order_lopande_TB_Avdrag"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
          
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
           
           <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta={`${TB1Lable}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_Varde_TB"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
          
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Order värde TG" MetaN={"Order_Varde_TG"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_TB")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'option.Revenue' })}`} MetaN={"Order_Varde_TB_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_TB")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'option.Cost' })}`} MetaN={"Order_Varde_TB_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_TB")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
            <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'Budget.OrderValue' })}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_lopande"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
        
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ordervärde intäkt" MetaN={"Order_lopande_intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ordervärde kostnad" MetaN={"Order_lopande_kostnad"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
            <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'OnGoing' })}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_lopande1"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'OnGoing.revenue' })}`} MetaN={"Order_lopande1_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande1")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB1Lable} ${props.intl.formatMessage({ id: 'Label.Order.Ongoing.Cost' })}`} MetaN={"Order_lopande1_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande1")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>   
           {
             parseInt(Flags.KalkylPlus) === 1?
             <>
              <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
              <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
              <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
                <CheckBoxInput Meta={`${TB2Lable}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_Varde_TB2"} disabled={false} Value={true} 
                onChangeMstate={props.onChangeMstate} 
                Mstate={props.Chips}
                />
              </Grid>
              <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'option.Revenue' })}`} MetaN={"Order_Varde_TB2_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_TB2")} Value={true} 
                onChangeMstate={props.onChangeMstate} 
                Mstate={props.Chips}
                />
            </Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'option.Cost' })}`} MetaN={"Order_Varde_TB2_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_TB2")} Value={true} 
                onChangeMstate={props.onChangeMstate} 
                Mstate={props.Chips}
                />
            </Grid>
            <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
            <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'Budget.OrderValue' })}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_lopande2"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
        
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'Label.Order.Value.Income' })}`} MetaN={"Order_lopande2_intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande2")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'Label.Order.Value.Cost' })}`} MetaN={"Order_lopande2_kostnad"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande2")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
            <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'OnGoing' })}`} tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_lopande21"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'OnGoing.revenue' })}`} MetaN={"Order_lopande21_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande21")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta={`${TB2Lable} ${props.intl.formatMessage({ id: 'Label.Order.Ongoing.Cost' })}`} MetaN={"Order_lopande21_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_lopande21")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>   
            </>
            :""
           }   
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
           <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta="Utpris" tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_Varde_Utpris1"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris intäkt" MetaN={"Order_Varde_Utpris_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_Utpris1")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris kostnad" MetaN={"Order_Varde_Utpris_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_Utpris1")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>  
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid> 
           <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta="Utpris ordervärde" tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_Varde_ordervarde_Utpris"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris ordervärde intäkt" MetaN={"Order_Varde_ordervarde_Utpris_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_ordervarde_Utpris")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris ordervärde kostnad" MetaN={"Order_Varde_ordervarde_Utpris_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_ordervarde_Utpris")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>      
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>    
           <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={4} >
           <CheckBoxInput Meta="Utpris löpande"  tooltip={props.intl.formatMessage({ id: 'Toottips.incomeCost' })} MetaN={"Order_Varde_lopande_Utpris"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
            <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris löpande intäkt" MetaN={"Order_Varde_lopande_Utpris_Intakter"} disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_lopande_Utpris")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Utpris löpande kostnad" MetaN={"Order_Varde_lopande_Utpris_Kostnader"}  disabled={!props.Chips.some(item=>item.MetaN === "Order_Varde_lopande_Utpris")} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"pt-1"}  xs={12} md={12} lg={12} ></Grid>
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Total omsättning (Löpande)per månad" MetaN={"Order_Varde_lopande_TB_Monthly"}   Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Total omsättning (Utpris)per månad" MetaN={"Order_Varde_lopande_Utpris_Monthly"}  Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Order registrering datum" MetaN={"Order_Regdate"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Order skapad datum" MetaN={"Order_skapadDate"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} ><Divider/></Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={12} ><IntlMessages id="Free.Inputs"/></Grid>
            {
                !isEmpty(OrderFreeInputsList)?
                    !isEmpty(OrderFreeInputsList.filter(item=>item.inRapport === 1))?
                    OrderFreeInputsList.filter(item=>item.inRapport === 1).map(item=>{
                        return <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                        <CheckBoxInput Meta={item.Meta} MetaN={`Order_Free_Inputs_${item.Meta}`} disabled={false} Value={true} 
                        onChangeMstate={props.onChangeMstate} 
                        Mstate={props.Chips}
                        />
                        </Grid>
                    })
                    :""
                :""
            }
           </Grid>
        </>
    );
}
export default injectIntl(OrderSection);